import React from 'react';
const biContext = React.createContext(null);
export const BiProvider = biContext.Provider;
export const WithBi = (WrappedComponent) => { var _a; return _a = class extends React.Component {
        render() {
            const newProps = {
                ...this.props,
                biLogger: this.context,
            };
            return React.createElement(WrappedComponent, newProps);
        }
    },
    _a.contextType = biContext,
    _a; };
//# sourceMappingURL=provider.js.map